export const theme = {
  colors: {
    darkBlue: "#0A192F",
    lightBlue: "#112240",
    gray: "#8892B0",
    teal: "#4FD1C5",
    white: "#FFFFFF",
    highlight: "#FFC107",
  },
  fonts: {
    main: "'Roboto', sans-serif", // General UI, body text
    heading: "'Montserrat', sans-serif", // Headlines, banners
    code: "'IBM Plex Mono', monospace", // Code snippets, data displays
    secondary: "'IBM Plex Sans', sans-serif", // Secondary text, maybe captions or less emphasized text
    accent: "'Source Sans Pro', sans-serif", // UI elements, buttons, or small text that needs to be legible
    highlight: "'Oswald', sans-serif" // Used for call-to-actions, important navigational links
  },
};
